import Vue from 'vue'
import store from '@/store/store'
import * as Sentry from '@sentry/vue'
import router from '@/router'

const sentryService = {
  init (Vue, store) {
    Sentry.init({
      Vue: Vue,

      dsn: window.sentry['dsn'] || '',
      denyUrls: [
        /clarity\.ms/i,
        /ms\.clarity/i
      ],
      beforeBreadcrumb (breadcrumb) {
        if (breadcrumb?.message?.includes('clarity')) return null
        return breadcrumb
      },
      beforeSend (event, hint) {
        const err = hint?.originalException
        // Ігноруємо помилки що прийшли з Clarity
        if (err?.stack?.includes('clarity')) return null
        if (err?.stack?.includes('ms.clarity')) return null

        // Не відправляємо до Sentry повідомлення рівня log та info
        if (['log', 'info'].includes(event.level)) {
          return null
        }

        return event
      },
      environment: window.sentry['environment'] || 'undefined',
      release: window.sentry['release'] || '',
      tracesSampleRate:
        parseFloat(new URL(window.location).searchParams.get('traceme')) || window.sentry['tracesSampleRate'] || 0,
      tracingOptions: {
        trackComponents: true
      },
      integrations: [
        Sentry.browserTracingIntegration({
          router,
          routeLabel: 'name'
        }),
        Sentry.browserApiErrorsIntegration({
          setTimeout: false,
          setInterval: false,
          requestAnimationFrame: false,
          XMLHttpRequest: true,
          eventTarget: false
        }),
        Sentry.globalHandlersIntegration(),
        Sentry.breadcrumbsIntegration({
          console: false,
          dom: true,
          fetch: true,
          xhr: true,
          history: true,
          sentry: false
        })
      ]
    })

    store.watch(
      state => state.user.user_data,
      userData => {
        if (userData.user_id !== undefined) {
          Sentry.setUser({
            id: userData.user_id,
            email: userData.email
          })
        }
      }
    )
  }
}

export const setupSentryService = () => {
  if (window.sentry && +process.env.VUE_APP_SENTRY_ENABLED) {
    sentryService.init(Vue, store)
  }
}
